import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHourglass2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHourglass2"><Path fillRule="evenodd" clipRule="evenodd" d="M20 3.5H19V6C19 9.31371 16.3137 12 13 12L13.3086 12.0078C16.4789 12.1684 19 14.7898 19 18V20.5H20V22H4V20.5H5V18C5 14.7898 7.52111 12.1684 10.6914 12.0078L11 12C7.68629 12 5 9.31371 5 6V3.5H4V2H20V3.5ZM9.36719 16.8779C8.55089 17.1502 8.00019 17.9139 8 18.7744V19H16V18.7744C15.9998 17.9139 15.4491 17.1502 14.6328 16.8779L12 16L9.36719 16.8779Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHourglass2;
